export default "__VITE_ASSET__DUfyvwBl__"